import {
  BlogPublicCategory,
  BlogPublicPost,
  blogReadingMinutes,
} from '@/lib/entities/blog';

import { useTranslation } from 'next-i18next';

import styles from './BlogHubPage.module.scss';
import { ArticleCard } from './components/ArticleCard';
import { BlogHubChrome } from './components/BlogHubChrome';
import { BlogPagination } from './components/BlogPagination';

type BlogListingPageProps = {
  locale: string;
  categories: BlogPublicCategory[];
  tags?: string[];
  posts: BlogPublicPost[];
  currentPage: number;
  totalPages: number;
  hrefForPage: (page: number) => string;
  title: string;
  breadcrumbCurrent: string;
  activeCategorySlug?: string | null;
  searchDefault?: string;
  emptyLabel?: string;
  activeTag?: string | null;
};

export const BlogListingPage = ({
  locale,
  categories,
  tags = [],
  posts,
  currentPage,
  totalPages,
  hrefForPage,
  title,
  breadcrumbCurrent,
  activeCategorySlug = null,
  searchDefault = '',
  emptyLabel,
  activeTag = null,
}: BlogListingPageProps) => {
  const { t } = useTranslation('index', { keyPrefix: 'blog' });

  return (
    <div className={styles.hub}>
      <div className={styles.hub__container}>
        <BlogHubChrome
          locale={locale}
          categories={categories}
          tags={tags}
          title={title}
          breadcrumbCurrent={breadcrumbCurrent}
          activeCategorySlug={activeCategorySlug}
          searchDefault={searchDefault}
          activeTag={activeTag}
        />

        {posts.length > 0 ? (
          <section
            id="blog-latest"
            className={styles.hub__section}
            aria-labelledby="blog-latest-title"
          >
            <h2 id="blog-latest-title" className={styles.hub__sectionTitle}>
              {t('latest')}
            </h2>
            <div className={styles.hub__grid}>
              {posts.map((post) => (
                <ArticleCard
                  key={post.id}
                  post={post}
                  locale={locale}
                  readingLabel={t('readingTimeFull', {
                    count: blogReadingMinutes(post),
                  })}
                />
              ))}
            </div>
            <BlogPagination
              currentPage={currentPage}
              maxPages={totalPages}
              hrefForPage={hrefForPage}
            />
          </section>
        ) : (
          <p className={styles.hub__empty}>{emptyLabel || t('empty')}</p>
        )}
      </div>
    </div>
  );
};
